import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC, useEffect, useRef } from "react";
import PageProps from "@insite/client-framework/Types/PageProps";
import { ResolveThunks, useDispatch, useSelector } from "react-redux";
import { HasToasterContext } from "@insite/mobius/Toast/ToasterContext";
import { HasHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { css } from "styled-components";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
// import loadPricingStatus from "./PricingStatusHandler";
import DispatchGetcustomerStatusApi from "./PricingStatusHandler";
import translate from "@insite/client-framework/Translate";
import ADIColors from "@NA/Utils/ADIColors";
import siteMessage from "@insite/client-framework/SiteMessage";

export interface ADINewCustomerBannerStyles {
    newCustomerParent: InjectableCss;
    textarea: InjectableCss;
}

export const newCustomerPriceBanner: ADINewCustomerBannerStyles = {
    newCustomerParent: {
        css: css`
            width: 100%;
            padding: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #ac1e2d;
            font-family: "Nunito Sans", sans-serif;
            font-weight: 700;
        `,
    },
    textarea: {
        css: css`
            font-size: 16px;
            line-height: 20px;
            color: ${ADIColors.white};
            text-align: center;
        `,
    },
};

const styles = newCustomerPriceBanner;

type Props = PageProps & HasToasterContext & HasHistory;

const ADINewCustomerPricingUnavilableBanner: FC<Props> = () => {
    const dispatch = useDispatch();
    const onLoadRef = useRef(false);
    const currentState = useSelector((state: CustomApplicationState) => state);

    // commented due to api/v2/account/customerstatus?CustomerNumber=49489 is calling 

    // const loadADIPricingStatus = () => {
    //     const cart = getCurrentCartState(currentState);
    //     const billToState = getBillToState(currentState, cart?.value?.billToId);
    //     if (billToState.value && billToState.value.customerNumber) {
    //         onLoadRef.current = true;
    //         dispatch(
    //             loadPricingStatus({
    //                 userID: billToState.value?.customerNumber,
    //             }),
    //         );
    //     }
    // };

   

    

    

    const displayBannerText = () => {
        if (
            currentState &&
            currentState.ADIGlobalData.PricingStatusStore &&
            !currentState.components.addressDrawer.navDrawerIsOpen &&
            !currentState.ADIGlobalData.PricingStatusStore.isSearchBarOpen &&
            !currentState.ADIGlobalData.PricingStatusStore.isPdpSticky &&
            currentState.ADIGlobalData.PricingStatusStore.pricingStatus &&
            currentState.ADIGlobalData.PricingStatusStore.pricingStatus.billStatus &&
            currentState.ADIGlobalData.PricingStatusStore.pricingStatus.billStatus.toLowerCase() === "n"
        ) {
            return (
                <StyledWrapper {...styles.newCustomerParent}>
                    <StyledWrapper {...styles.textarea}>{siteMessage("PendingVerificationMessage")}</StyledWrapper>
                </StyledWrapper>
            );
        } else {
            return null;
        }
    };

    return <>{displayBannerText()}</>;
};

const widgetModule: WidgetModule = {
    component: ADINewCustomerPricingUnavilableBanner,
    definition: {
        group: "Basic",
        displayName: "ADI New Customer Pricing Unavilable Banner",
    },
};

export default widgetModule;
